/**
 * A one-line spoken summary of a property-list row for Parkhi — the property
 * equivalent of cammyCaseSummary.js. Kept separate rather than shared: the
 * property list's row shape (address/displayId, no warnings at list level —
 * see propertyAssessment.js's toPropertyListRow) doesn't match the motor
 * list's (caseId/refNum/warnings), and forcing one function to cover both
 * would mean every caller passing fields the other shape doesn't have.
 *
 * Built only from what the property list already fetched for its own row —
 * no warnings field exists at the list level, so none is attempted here.
 */
export const summarizePropertyCaseForCammy = ({
  address,
  displayId,
  country,
  statusText,
  receivedAt,
} = {}) => {
  const lead = address && address !== "—" ? address : displayId || "This property";
  const status = statusText ? `is ${statusText}` : null;

  const facts = [];
  if (country) facts.push(country);
  if (receivedAt) facts.push(`received ${receivedAt}`);

  let sentence = [lead, status].filter(Boolean).join(" ");
  if (facts.length) sentence += ` — ${facts.join(", ")}`;

  return `${sentence}.`;
};

export default summarizePropertyCaseForCammy;
